export default __webpack_public_path__ + "static/media/imageedit_13_5201923858.c8f5ec51.png";